import React  from 'react';
import { List, Segment, Divider, Table, Grid, Image, Header, Icon, Accordion} from 'semantic-ui-react';
import { Link } from "react-router-dom";

import '../../App.css';
 


const Modulos=({ id, margenes, modulos, onAcordionModulo, olor, form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos})=>{

    
     
     
	return (
        <Segment basic style={margenes}>
        <Header as='h2' dividing>
            {strings?strings["Modulos"]:""}
        </Header>
        {modulos.map(modulo =>
        <div>
        <Segment attached secondary clearing>
                <Header as='h4' floated='left'>
                     {modulo.titulo}
                    <Header.Subheader>
                       {modulo.contenido.length} {strings?strings["actividades"]:""}
                    </Header.Subheader>
                </Header>
                <Header as='h6' floated='right'>

                    <Icon size="tiny" color={modulo.activo?"grey":"blue"}  name={modulo.activo?"minus":"plus"} link onClick={()=>onAcordionModulo(modulo.id)}/>
                </Header>
    
        </Segment>
        {modulo.activo?
        <Segment attached>
            {modulo.contenidoView.map(rowView =>
         <Table  celled attached>
            <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='2'>{rowView.agrupador+" - "+rowView.fecha}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                            <Table.Body>
                                 {rowView.contenido.map(row =>
                                      <Table.Row>
           
                                        <Table.Cell>{row.titulo}</Table.Cell>
                                        
                                        <Table.Cell width="1">
                                          <Icon size="large" color={row.color}  name={row.icon} />
                                        </Table.Cell>
                                      </Table.Row>
                                )}	
                            </Table.Body>
                        </Table>
        )}
        </Segment>:""}
        </div>
        )}	
    
        
     
        </Segment>
	);
};



export default Modulos;